import { canv } from "@/canv/global.js";
import { wmBase } from "@/widgetMenu/wmBase";

export class wmEdit extends wmBase {
    constructor(options) {
        super();
        this.options = options;
    }

    build() {
        if (
            canv.canvasController.selected.length !== 1 ||
            !canv.canvasController.selected[0].isItemWrapper()
        )
            return "";

        return `
            <div class="wm_edit">
            <svg width="23" height="23" viewBox="0 0 24 24">
                <g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                <line x1="15" x2="17.293" y1="6" y2="8.293" stroke="#1D1D1F" stroke-width="1.5"/>
                <path stroke="#1D1D1F" stroke-width="1.5" d="M4.47642977,16.1649916 L4,19.5 L4,19.5 L7.33500842,19.0235702 C7.44210621,19.0082705 7.54135271,18.9586473 7.61785113,18.8821489 L19.5,7 L19.5,7 L16.5,4 L4.61785113,15.8821489 C4.54135271,15.9586473 4.49172946,16.0578938 4.47642977,16.1649916 Z"/>
                </g>
            </svg>
        `;
    }

    init() {
        const item = document.querySelector(".wm_edit");
        if (!item) {
            return;
        }

        item.addEventListener("mouseup", this.itemClick.bind(this), false);
    }

    itemClick() {
        const otherSubm = document.querySelector(".widgetSubMenu");
        if (otherSubm) {
            otherSubm.outerHTML = "";
        }

        this.applyValue(this.options, this.text);
    }

    name = "wm_edit";
    options = [];
    text = "";
}
